<div #modalContainer class="tm-cnt-ext" style="display: none;">
    <div class="tm-cnt" [ngClass]="{'tm-cnt-mobile' : isMobile}">
        <div class="tm-cnt-title">
            <div class="tm-ico-cnt"
                [ngClass]="{'tm-info-bg' : (modalType == 'info' || modalType == 'confirm'), 'tm-success-bg' : modalType == 'success', 'tm-error-bg' : modalType == 'error'}">
                <span *ngIf="modalType == 'info'" class="tm-icon">&#105;</span>
                <span *ngIf="modalType == 'success'" class="tm-icon">&#10003;</span>
                <span *ngIf="modalType == 'error'" class="tm-icon">&#10005;</span>
                <span *ngIf="modalType == 'confirm'" class="tm-icon">?</span>
            </div>
            <span class="te-title">{{modalTitle}}</span>
        </div>
        <div class="tm-cnt-body">
            <span class="te-message" [innerHTML]="modalMessage"></span>
        </div>
        <div *ngIf="showNotesInput" class="modal-notes-container">
            <!-- <label for="modal-notes">{{ notesLabel }}</label> -->
            <textarea id="modal-notes" [(ngModel)]="notes" rows="4" placeholder="Notes...">
  </textarea>
        </div>

        <div class="tm-cnt-btn" [ngClass]="{'tm-cnt-btn-mobile' : isMobile}">
            <!-- CONFIRM -->
            <teiasoft-button *ngIf="modalType == 'confirm'" (onClick)="onConfirmModalClick()" class="mr-5"
                [text]="'commons.yes' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button *ngIf="modalType == 'confirm'" (onClick)="onCancelModalClick()" class="mr-5"
                [type]="'tb-cancel'" [text]="'commons.no' | translate" [isMobile]="isMobile"></teiasoft-button>
            <!-- DISCARD -->
            <teiasoft-button *ngIf="modalType == 'discard'" (onClick)="onApplyModalClick()" class="mr-5"
                [type]="'tb-primary'" [text]="'commons.apply' | translate" [theme]="theme"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button *ngIf="modalType == 'discard'" (onClick)="onDiscardModalClick()" class="mr-5"
                [type]="'tb-secondary'" [text]="'commons.discard' | translate" [isMobile]="isMobile"></teiasoft-button>
            <!-- CLOSE -->
            <teiasoft-button
                *ngIf="modalType == 'discard' || modalType == 'info' || modalType == 'success' || modalType == 'error'"
                (onClick)="onCloseModalClick()" [text]="'commons.close' | translate" [theme]="theme"
                [isMobile]="isMobile" [type]="'tb-cancel'"></teiasoft-button>
        </div>
    </div>
</div>
